import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  companyDetails: {},
  fetchingDropdown: false,
  dropdowns: {},
  updating: false,
  tests: [],
  companyCatalog: [],
  fetchingCompanyDetails: false,
  testCount: 0,
  commodityCategories: [],
  commodities: [],
  testCategories: [],
  filters: {},
  fetchingFilters: false,
};

const companyCatalogAddSlice = createSlice({
  name: "companyCatalogAdd",
  initialState,
  reducers: {
    fetchCatalog(state, action) {
      state.loading = true;
    },
    fetchCatalogSuccess(state, action) {
      state.tests = action.payload.data.document;
      state.testCount = action.payload.count;
      state.loading = false;
    },
    fetchCatalogFailure(state, action) {
      state.loading = false;
    },
    fetchFilters(state, action) {
      state.fetchingFilters = true;
    },
    fetchFiltersSuccess(state, action) {
      state.filters = action.payload.data.document;
      state.fetchingFilters = false;
    },
    fetchFiltersFailure(state, action) {
      state.fetchingFilters = false;
    },
    fetchDropdown(state, action) {
      state.fetchingDropdown = true;
    },
    fetchDropdownSuccess(state, action) {
      state.fetchingDropdown = false;
      state.dropdowns = action.payload.data.document;
    },
    fetchDropdownFailure(state, action) {
      state.fetchingDropdown = false;
    },
    updateCatalog(state, action) {
      state.updating = true;
    },
    updateCatalogSuccess(state, action) {
      state.companyDetails = action.payload.data.document;
      state.updating = false;
    },
    updateCatalogFailure(state, action) {
      state.updating = false;
      state.error = action.payload.message;
    },
    initializeError(state, action) {
      state.error = null;
    },
    fetchCompanyDetails(state, action) {
      state.fetchingCompanyDetails = true;
      state.companyDetails = {};
    },
    fetchCompanyDetailsSuccess(state, action) {
      state.companyDetails = action.payload.data.document;
      state.fetchingCompanyDetails = false;
    },
    fetchCompanyDetailsFailure(state, action) {
      state.fetchingCompanyDetails = false;
      state.companyDetails = {};
    },
    fetchCompanyCatalog(state, action) {
      state.loading = true;
    },
    fetchCompanyCatalogSuccess(state, action) {
      state.companyCatalog = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyCatalogFailure(state, action) {
      state.loading = false;
    },
    fetchCommodityCategories(state, action) {
      state.loading = true;
    },
    fetchCommodityCategoriesSuccess(state, action) {
      state.commodityCategories = action.payload.data?.document;
      state.loading = false;
    },
    fetchCommodityCategoriesFailure(state, action) {
      state.loading = false;
    },
    fetchCommodity(state, action) {
      state.loading = true;
    },
    fetchCommoditySuccess(state, action) {
      state.commodities = action.payload.data?.document;
      state.loading = false;
    },
    fetchCommodityFailure(state, action) {
      state.loading = false;
    },
    fetchTestCategory(state, action) {
      state.loading = true;
    },
    fetchTestCategorySuccess(state, action) {
      state.testCategories = action.payload.data?.document;
      state.loading = false;
    },
    fetchTestCategoryFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = companyCatalogAddSlice;
